module.exports = __webpack_public_path__ + "img/tensorflow.c32de6ab.png";